import { BulkParseResult } from '../../hooks/BulkUpload/parseBulkCodes';
import FailedResultView from './BulkUploadModal/FailedResultView';
import { BulkFailureItem } from './BulkUploadFailuresByReason';
import { Option } from '@/components/inputs/AutocompleteInput';
import ProcessingView from './BulkUploadModal/ProcessingView';
import InputView from './BulkUploadModal/InputView';
import { Dialog } from '@mui/material';

type BulkUploadPhase = 'input' | 'processing' | 'failed';
type ProcessingStage = 'validating' | 'executing' | null;

interface BulkUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  transition: Option | null;
  setTransition: (option: Option | null) => void;
  transitionOptions: Option[];
  isTransitionsLoading: boolean;
  rawText: string;
  setRawText: (value: string) => void;
  parseStats: BulkParseResult['stats'];
  unrecognizedLines: string[];
  phase: BulkUploadPhase;
  processingStage: ProcessingStage;
  progress: { done: number; total: number };
  failures: BulkFailureItem[];
  resultMessage: string;
  canSubmit: boolean;
  onConfirm: () => void;
  onCloseFailedResult: () => void;
}

const BulkUploadModal = ({
  isOpen,
  onClose,
  transition,
  setTransition,
  transitionOptions,
  isTransitionsLoading,
  rawText,
  setRawText,
  parseStats,
  unrecognizedLines,
  phase,
  processingStage,
  progress,
  failures,
  resultMessage,
  canSubmit,
  onConfirm,
  onCloseFailedResult,
}: BulkUploadModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, p: 1.5 } }}
    >
      {phase === 'failed' ? (
        <FailedResultView
          resultMessage={resultMessage}
          failures={failures}
          onClose={onCloseFailedResult}
        />
      ) : phase === 'processing' ? (
        <ProcessingView processingStage={processingStage} progress={progress} />
      ) : (
        <InputView
          transition={transition}
          setTransition={setTransition}
          transitionOptions={transitionOptions}
          isTransitionsLoading={isTransitionsLoading}
          rawText={rawText}
          setRawText={setRawText}
          parseStats={parseStats}
          unrecognizedLines={unrecognizedLines}
          canSubmit={canSubmit}
          onClose={onClose}
          onConfirm={onConfirm}
        />
      )}
    </Dialog>
  );
};

export default BulkUploadModal;
